var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWarningLinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 52 52"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#D87906",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M12.9845 5.08859C16.7757 2.77229 21.232 1.4375 26 1.4375C39.8071 1.4375 51 12.6304 51 26.4375C51 40.2446 39.8071 51.4375 26 51.4375C12.1929 51.4375 1 40.2446 1 26.4375C1 22.5151 1.9033 18.8037 3.51323 15.5M32.9282 24.4375L38.1243 33.4375C38.8941 34.7708 37.9319 36.4375 36.3923 36.4375H15.6077C14.0681 36.4375 13.1058 34.7708 13.8756 33.4375L24.2679 15.4375C25.0377 14.1042 26.9622 14.1042 27.732 15.4375L29.4641 18.4375M26 22.4375V28.4375"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#D87906",
  stroke: "#D87906",
  d: "M26 30.9375C26.2761 30.9375 26.5 31.1614 26.5 31.4375C26.5 31.7136 26.2761 31.9375 26 31.9375C25.7239 31.9375 25.5 31.7136 25.5 31.4375C25.5 31.1614 25.7239 30.9375 26 30.9375Z"
})));
export default SvgWarningLinline;